import { createSlice } from "@reduxjs/toolkit";

const sliceName = "sort";

const initialState = {
    value: "default"
};

const sortSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        sortedBy: (state, action) => {
            state.value = action.payload;
        }
    }
});

export const { sortedBy } = sortSlice.actions;
export default sortSlice.reducer;